/* ═══════════════════════════════════════════════════════════
   MIRAH — GLOBAL JAVASCRIPT v2.0
   GSAP Animations · Mobile Nav · AJAX Cart · Premium Interactions
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ─────────────────────────────────────────
     ANIMATION ENGINE (IntersectionObserver)
  ───────────────────────────────────────── */
  const initAnimations = () => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el);
    });
    
    // Auto-stagger children if container has data-animate-stagger
    document.querySelectorAll('[data-animate-stagger]').forEach(container => {
      const items = container.querySelectorAll('.stagger-item, .bento-item, .pcard');
      items.forEach((item, index) => {
        item.setAttribute('data-animate', 'fade-up');
        item.classList.add(`delay-${Math.min(index + 1, 5)}`);
        observer.observe(item);
      });
    });

    /* Infinite Marquee */
    document.querySelectorAll('.marquee').forEach(marquee => {
      const inner = marquee.querySelector('.marquee__inner');
      if (!inner) return;
      const content = inner.innerHTML;
      inner.innerHTML = content + content + content + content;
      // CSS animations will handle this, or we can use WAAPI
      inner.animate(
        [ { transform: 'translateX(0)' }, { transform: 'translateX(-50%)' } ],
        { duration: 28000, iterations: Infinity, easing: 'linear' }
      );
    });

    /* Magnetic Buttons */
    document.querySelectorAll('.btn-magnetic').forEach(btn => {
      const inner = btn.querySelector('.btn-magnetic__inner');
      if (!inner) return;
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.28;
        const y = (e.clientY - r.top - r.height / 2) * 0.28;
        inner.style.transform = `translate(${x}px, ${y}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        inner.style.transform = `translate(0px, 0px)`;
      });
    });
  };

  initAnimations();


  /* ─────────────────────────────────────────
     HEADER — Scroll & Transparency
  ───────────────────────────────────────── */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('header--scrolled', window.scrollY > 40);
    }, { passive: true });
  }


  /* ─────────────────────────────────────────
     MOBILE MENU
  ───────────────────────────────────────── */
  const hamburger   = document.querySelector('[data-mobile-toggle]');
  const mobileNav   = document.querySelector('[data-mobile-nav]');
  const overlay     = document.querySelector('[data-mobile-overlay]');
  const closeBtn    = document.querySelector('[data-mobile-close]');

  const closeMobileNav = () => {
    hamburger?.classList.remove('is-active');
    mobileNav?.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  hamburger?.addEventListener('click', () => {
    const isOpen = mobileNav?.classList.contains('is-open');
    isOpen ? closeMobileNav() : (() => {
      hamburger.classList.add('is-active');
      mobileNav?.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    })();
  });

  closeBtn?.addEventListener('click', closeMobileNav);
  overlay?.addEventListener('click', closeMobileNav);
  mobileNav?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileNav));

  /* Mobile accordion (Shop submenu) */
  document.querySelectorAll('[data-mobile-accordion]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const sub = trigger.nextElementSibling;
      if (!sub) return;
      const isOpen = sub.style.maxHeight && sub.style.maxHeight !== '0px';
      sub.style.maxHeight = isOpen ? '0' : sub.scrollHeight + 'px';
      const chevron = trigger.querySelector('svg');
      if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
    });
  });


  /* ─────────────────────────────────────────
     ANNOUNCEMENT BAR DISMISS
  ───────────────────────────────────────── */
  const annClose = document.querySelector('.announcement-bar__close');
  annClose?.addEventListener('click', () => {
    const bar = annClose.closest('.announcement-bar');
    if (bar) { bar.style.maxHeight = '0'; bar.style.overflow = 'hidden'; }
  });


  /* ─────────────────────────────────────────
     PRODUCT PAGE — Gallery, Quantity, Accordion
  ───────────────────────────────────────── */
  // Thumbnail swap
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('[data-main-image]');
      if (main) main.src = thumb.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Quantity selector
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-wrapper')?.querySelector('.qty-input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      input.value = btn.dataset.action === '+' ? val + 1 : Math.max(1, val - 1);
    });
  });

  // Accordion
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('is-open');
      document.querySelectorAll('.accordion__trigger.is-open').forEach(t => {
        t.classList.remove('is-open');
        t.nextElementSibling.style.maxHeight = '0';
      });
      if (!isOpen) {
        trigger.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });


  /* ─────────────────────────────────────────
     CART NOTIFICATION TOAST
  ───────────────────────────────────────── */
  window.showCartToast = (message) => {
    const toast = document.querySelector('.cart-notification');
    const text  = toast?.querySelector('.cart-notification__text');
    if (!toast) return;
    if (text) text.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2800);
  };

});


/* ─────────────────────────────────────────
   AJAX ADD TO CART (global, used by pcard)
───────────────────────────────────────── */
async function pcardAddToCart(btn) {
  const card = btn.closest('[data-product-id]');
  const variantId = btn.dataset.variantId;
  const textEl = btn.querySelector('.pcard__btn-text');
  const loadEl = btn.querySelector('.pcard__btn-loading');

  btn.classList.add('adding');
  if (textEl) textEl.style.display = 'none';
  if (loadEl) loadEl.style.display = 'block';

  // Try to resolve a size-specific variant
  const activeSize = card?.querySelector('.pcard__size--active');
  let finalId = variantId;

  if (activeSize) {
    const pid = card.dataset.productHandle;
    const resolved = await getVariantForSize(pid, activeSize.dataset.size);
    if (resolved) finalId = resolved;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: finalId, quantity: 1 })
    });

    if (!res.ok) throw new Error();

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    updateHeaderCart(cart);

    // Success state
    btn.classList.remove('adding');
    btn.classList.add('added');
    if (textEl) { textEl.textContent = '✓ Added'; textEl.style.display = ''; }
    if (loadEl) loadEl.style.display = 'none';

    if (window.showCartToast) window.showCartToast('Added to bag');

    setTimeout(() => {
      btn.classList.remove('added');
      if (textEl) textEl.textContent = 'Add to Cart';
    }, 2200);

  } catch {
    btn.classList.remove('adding');
    btn.classList.add('error');
    if (textEl) { textEl.textContent = 'Try again'; textEl.style.display = ''; }
    if (loadEl) loadEl.style.display = 'none';
    setTimeout(() => {
      btn.classList.remove('error');
      if (textEl) textEl.textContent = 'Add to Cart';
    }, 2200);
  }
}

/* Header cart: refresh the count badge and the tooltip list (products only — no prices) from /cart.js data */
function updateHeaderCart(cart) {
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
    el.hidden = cart.item_count === 0;
  });

  const shown = cart.items.slice(0, 4);
  const listHtml = shown.length
    ? shown.map(item => {
        const img = item.image ? `<img src="${esc(item.image)}${item.image.includes('?') ? '&' : '?'}width=96" alt="" width="36" height="48" loading="lazy">` : '';
        const variant = item.variant_title && !item.product_has_only_default_variant ? `<span class="header-cart__variant">${esc(item.variant_title)}</span>` : '';
        return `<li class="header-cart__item">${img}<span class="header-cart__meta"><span class="header-cart__title">${esc(item.product_title)}</span>${variant}</span><span class="header-cart__qty">&times; ${item.quantity}</span></li>`;
      }).join('')
    : '<li class="header-cart__empty">Your bag is empty</li>';

  document.querySelectorAll('[data-cart-tooltip-list]').forEach(el => { el.innerHTML = listHtml; });
  document.querySelectorAll('[data-cart-tooltip-more]').forEach(el => {
    const extra = cart.items.length - shown.length;
    el.hidden = extra <= 0;
    el.textContent = `+ ${extra} more`;
  });
}

/* Buy Now: add the chosen variant to the cart, then go straight to checkout.
   If the AJAX add fails, fall back to the link's cart permalink (/cart/<id>:1), which also opens checkout. */
async function pcardBuyNow(btn) {
  if (btn.classList.contains('adding')) return;
  btn.classList.add('adding');
  const card = btn.closest('[data-product-id]');
  let variantId = btn.dataset.variantId;

  const activeSize = card?.querySelector('.pcard__size--active');
  if (activeSize) {
    const resolved = await getVariantForSize(card.dataset.productHandle, activeSize.dataset.size);
    if (resolved) variantId = resolved;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error();
    window.location.href = '/checkout';
  } catch {
    window.location.href = `/cart/${variantId}:1`;
  }
}

async function getVariantForSize(productHandle, size) {
  try {
    const r = await fetch(`/products/${productHandle}.js`);
    const data = await r.json();
    const v = data.variants.find(v =>
      v.available && v.options.some(o => o.toLowerCase() === size.toLowerCase())
    );
    return v?.id || null;
  } catch { return null; }
}

/* Swatch + size delegation */
document.addEventListener('click', e => {
  const size = e.target.closest('.pcard__size');
  if (size) {
    size.closest('.pcard__sizes')?.querySelectorAll('.pcard__size')
      .forEach(s => s.classList.remove('pcard__size--active'));
    size.classList.add('pcard__size--active');
  }
  const swatch = e.target.closest('.pcard__swatch');
  if (swatch) {
    swatch.closest('.pcard__swatches')?.querySelectorAll('.pcard__swatch')
      .forEach(s => s.classList.remove('pcard__swatch--active'));
    swatch.classList.add('pcard__swatch--active');
  }
});
